var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer"},[(!_vm.$auth.loading)?_c('div',[(_vm.$auth.isAuthenticated)?_c('center',[_c('p',[_vm._v("Du er logget ind som "+_vm._s(_vm.$auth.user.name))]),_c('StdButton',{attrs:{"text":"Log ud","color":"var(--text)"},on:{"click":_vm.logout}})],1):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }